module.exports = __webpack_public_path__ + "static/img/cert-05.b511671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert/cert-05.jpg
// module id = aJy8
// module chunks = 1